module.exports = `:root {
  --primitiveColorNeutralBase910: #e5e5e5;
  --primitiveColorNeutralDarker820: #cccccc;
  --primitiveColorNeutralDark870: #dbdbdb;
  --primitiveColorNeutralLight940: #efefef;
  --primitiveColorNeutralLighter980: #f9f9f9;
  --primitiveColorPrimaryBase610: #6da300;
  --primitiveColorPrimaryDarker290: #334d00;
  --primitiveColorPrimaryDark490: #558000;
  --primitiveColorPrimaryLight730: #9cc00f;
  --primitiveColorPrimaryLighter770: #a6ca5f;
  --primitiveColorSecondaryBase430: #cc0000;
  --primitiveColorSecondaryDarker390: #b80000;
  --primitiveColorSecondaryDark410: #c20000;
  --primitiveColorSecondaryLight460: #d60000;
  --primitiveColorSecondaryLighter480: #e00000;
  --primitiveColorDarkBase170: #2a2a2a;
  --primitiveColorDarkDarker70: #161616;
  --primitiveColorDarkDark120: #202020;
  --primitiveColorDarkLight220: #343434;
  --primitiveColorDarkLighter330: #4d4d4d;
  --primitiveColorLightBase1000: #ffffff;
  --primitiveColorLightDarker930: #ebebeb;
  --primitiveColorLightDark970: #f5f5f5;
  --primitiveColorCorrectBase610: #6da300;
  --primitiveColorCorrectDarker310: #295408;
  --primitiveColorCorrectDark560: #62943b;
  --primitiveColorCorrectLight920: #e3edc6;
  --primitiveColorCorrectLighter950: #eff4da;
  --primitiveColorErrorBase270: #850000;
  --primitiveColorErrorDarker180: #5d0000;
  --primitiveColorErrorDark240: #780000;
  --primitiveColorErrorLight760: #dab3b3;
  --primitiveColorErrorLighter920: #f3e6e6;
  --primitiveColorTextBase350: #535353;
  --primitiveColorTextDarker270: #3f3f3f;
  --primitiveColorTextDark310: #494949;
  --primitiveColorTextLight500: #777777;
  --primitiveColorTextLighter620: #979797;
  --primitiveColorHighlightBase920: #dbeaf0;
  --primitiveColorHighlightDarker850: #c7d6dc;
  --primitiveColorHighlightDark880: #d1e0e6;
  --primitiveColorHighlightLight950: #e5f4fa;
  --primitiveColorHighlightLighter990: #effeff;
  --primitiveColorBorderBase830: #d3cece;
  --primitiveColorBorderDarker750: #bdb6b6;
  --primitiveColorBorderDark780: #c7c0c0;
  --primitiveColorBorderLight870: #ddd8d8;
  --primitiveColorBorderLighter900: #e7e2e2;
  --primitiveColorDisabledBase800: #c6c6c6;
  --primitiveColorDisabledDarker730: #b2b2b2;
  --primitiveColorDisabledDark760: #bcbcbc;
  --primitiveColorDisabledLight830: #d0d0d0;
  --primitiveColorDisabledLighter870: #dadada;
  --primitiveColorTanBase880: #e6dcd1;
  --primitiveColorTanDarker660: #ab9f91;
  --primitiveColorTanDark840: #d7d1cb;
  --primitiveColorTanLight930: #efe9e2;
  --primitiveColorTanLighter940: #f2ede7;
  --primitiveColorFocusBase583: #4191d8;
  --primitiveColorFocusDarker383: #1e4d95;
  --primitiveColorFocusDark490: #2778bf;
  --primitiveColorFocusLight672: #6ba9e1;
  --primitiveColorFocusLighter766: #96c2e9;
  --primitiveColorWarningBase487: #c25100;
  --primitiveColorWarningDarker278: #702e00;
  --primitiveColorWarningDark422: #a54800;
  --primitiveColorWarningLight950: #fff1b8;
  --primitiveColorWarningLighter984: #fffbe6;
  --primitiveTypographyTypescale1: 3rem;
  --primitiveTypographyTypescale2: 2rem;
  --primitiveTypographyTypescale3: 1.75rem;
  --primitiveTypographyTypescale4: 1.5rem;
  --primitiveTypographyTypescale5: 1.25rem;
  --primitiveTypographyTypescale6: 1rem;
  --primitiveTypographyTypescale7: 0.875rem;
  --primitiveTypographyTypescale8: 0.75rem;
}
`;